module.exports = __webpack_public_path__ + "img/banner1.1620c42b.jpg";